/** @return {string} */
export function getRootDomain(domain) {
  if (domain == null || typeof domain !== 'string') return domain;

  const whitelist = [
    'author-p80902-e698666.adobeaemcloud.com',
    'author-p80902-e698666.adobeaemcloud.net',
    'author-p80902-e698665.adobeaemcloud.com',
    'author-p80902-e698665.adobeaemcloud.net',
    'author-p80902-e698709.adobeaemcloud.com',
    'author-p80902-e698709.adobeaemcloud.net',
  ];
  if (whitelist.includes(domain)) {
    return domain;
  }

  const root = domain.split('.').slice(1).join('.');
  return root;
}
